import MapControlLayer from '../MapControlLayer'

export default class RasterTileLayer extends MapControlLayer {
    constructor(id, dataStream) {
        super(id, dataStream);
    }
}